
import { ElementType, FC, HTMLAttributes } from 'react';

interface IEmptyCellProps extends HTMLAttributes<HTMLTableCellElement> {
	isHeader?: boolean;
	width?: number;
};

const EmptyCell: FC<IEmptyCellProps> = ( { isHeader = false, width = 32, children, ...otherProps } ) => {
	const Component: ElementType = isHeader ? "th" : "td";
	return (
		<Component style={{ width, height: '44px' }} {...otherProps}>
			{ children }
		</Component>
	);
};

export default EmptyCell;
